import { isAfter } from 'date-fns'

import { TODAY } from '../../../../../../const'
import { ValidatorRules } from '../../../../util/validator'
import { StrategyStepState } from '../strategy-slice'
import { validateDateField, validateNumberField } from './util'

export const protectionContinuousRules: ValidatorRules<StrategyStepState> = {
  protection_protectionAsset: [
    (state: StrategyStepState) => ({
      isValid: !!state.selectedStrategy.protection.continuous.protectionAsset
    })
  ],
  protectionLevel: state =>
    validateNumberField(
      'protectionLevel',
      state.selectedStrategy.protection.continuous.protectionLevel
    ),
  leverageRatio: state =>
    validateNumberField(
      'leverageRatio',
      state.selectedStrategy.protection.continuous.leverageRatio
    ),
  targetVolatility: state =>
    validateNumberField(
      'targetVolatility',
      state.selectedStrategy.protection.isApplyVolControl
        ? state.selectedStrategy.protection.continuous.targetVolatility
        : { min: 1, max: 100, value: 1 }
    )
}

export const protectionTermRules: ValidatorRules<StrategyStepState> = {
  protection_protectionAsset: [
    (state: StrategyStepState) => ({
      isValid: !!state.selectedStrategy.protection.term.protectionAsset,
      message: 'You have to select a protection asset'
    })
  ],
  protectionLevel: state =>
    validateNumberField('protectionLevel', state.selectedStrategy.protection.term.protectionLevel),
  leverageRatio: state =>
    validateNumberField('leverageRatio', state.selectedStrategy.protection.term.leverageRatio),
  targetVolatility: state => {
    if (state.selectedStrategy.protection.isApplyVolControl) {
      return validateNumberField(
        'targetVolatility',
        state.selectedStrategy.protection.term.targetVolatility
      )
    }
    return {
      isValid: true,
      message: null
    }
  },
  maturityDate: state => {
    if (!state.selectedStrategy.protection.term.maturityDate) {
      return {
        isValid: false,
        message: 'You must set a maturity date'
      }
    }

    const withinBounds = validateDateField(
      'maturityDate',
      state.selectedStrategy.protection.term.maturityDate
    )

    if (!withinBounds.isValid) {
      return {
        isValid: false,
        message: withinBounds.message
      }
    }

    const endDate = new Date(state.selectedStrategy.protection.term.maturityDate.value)
    const isValid = isAfter(endDate, TODAY)

    return {
      isValid,
      message: 'The maturity date has to be in the future'
    }
  }
}
